import { render } from "./TempCreate.vue?vue&type=template&id=0d75dc40"
import script from "./TempCreate.vue?vue&type=script&lang=js"
export * from "./TempCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__